import { Trans } from '@lingui/react'

import { useSubmitInstallmentsDisclaimerMutation } from '@twisto/api-graphql'
import { TextButton } from '@twisto/components/atoms/button'
import { Container } from '@twisto/components/atoms/container'
import { ModalSplitLayout, useIsInModal } from '@twisto/components/atoms/modal'

import {
  InstallmentsMinDueAmountHeadline,
  InstallmentsMinDueAmountTable,
} from '../../components'
import { useFlow } from '../../flow/flow.context'

import * as styles from './installments-disclaimer-step.styles'

export const InstallmentsDisclaimerStep = () => {
  const { sessionId, flow } = useFlow<'InstallmentsDisclaimerStep'>()
  const isCalledInModal = useIsInModal()

  const [submitInstallmentsDisclaimerStep, { loading }] =
    useSubmitInstallmentsDisclaimerMutation()

  const handleClick = () => {
    submitInstallmentsDisclaimerStep({
      variables: {
        auth: {
          sessionId,
        },
      },
    })
  }

  const { periodsMinPortion } = flow.currentStep

  const endContent = (
    <>
      <Container noPadding css={styles.tableSection} size="tiny">
        <InstallmentsMinDueAmountTable periodsMinPortion={periodsMinPortion} />
        <TextButton
          fullWidth
          data-testid="installments-minimum-due-amount-button"
          disabled={loading}
          onClick={handleClick}
        >
          <Trans id="flow.installmentsDisclaimerStep.continueButton" />
        </TextButton>
      </Container>
    </>
  )
  const startContent = <InstallmentsMinDueAmountHeadline />

  if (isCalledInModal) {
    return <ModalSplitLayout end={endContent} start={startContent} />
  }

  return (
    <>
      {startContent}
      {endContent}
    </>
  )
}
